// Iter-158.13.2.17d — Lifecycle endpoint resolver.
//
// Route 2 Production lifecycle (Archive / Unarchive) is served from
// the canonical `/api/beta/projects/{project_id}/…` prefix (see
// `beta_multidept.py:540-700`), NOT from `/api/beta/hm-app/projects/…`.
// FE call-sites inside a Route 2 workspace (`useApiBase()` returns
// `/beta/hm-app/projects`) that build a URL as
// `${apiBase}/${projectId}/archive` therefore hit an unmounted path
// and 404.
//
// This helper is the single source of truth for that mapping so
// every lifecycle button — ProjectSettings' Archive dialog,
// ArchiveBanner's Unarchive button, and any future lifecycle
// surface added to a workspace shell — resolves the same way
// without reconstructing Route 2 routes inline.
//
// Rules (kept intentionally narrow):
//   • Legacy context (`apiBase === "/projects"`) — `/projects/{id}/{action}`.
//   • Any Route 2 context (`apiBase` starts with `/beta/`) — the
//     canonical `/beta/projects/{id}/{action}` endpoint. This is the
//     SAME path MyProjects.jsx already trusts for its Route 2
//     Production Hub menu (see `MyProjects.jsx:353, 367`).
//   • Unknown apiBase — fall back to `${apiBase}/{id}/{action}` so a
//     future workspace with its own dedicated prefix keeps working
//     the way it declares itself.
//
// `action` is a bare verb ("archive", "unarchive"). No leading slash.
export function lifecycleEndpoint(apiBase, projectId, action) {
    if (!projectId || !action) {
        throw new Error("lifecycleEndpoint: projectId and action are required");
    }
    if (apiBase === "/projects") {
        return `/projects/${projectId}/${action}`;
    }
    if (typeof apiBase === "string" && apiBase.startsWith("/beta/")) {
        return `/beta/projects/${projectId}/${action}`;
    }
    return `${apiBase}/${projectId}/${action}`;
}
